import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://ewwbdltrbxmxyhfoztkv.supabase.co'
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV3d2JkbHRyYnhteHloZm96dGt2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIyNzQ3MjQsImV4cCI6MjA4Nzg1MDcyNH0.TKKQEcPn16L4Kou23U2NQc9RTJzgP5fhtXBJmTkAlmc'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)

// ─── Auth helpers ───

export async function signIn(
  email: string,
  password: string,
): Promise<{ success: boolean; error?: string }> {
  const { error } = await supabase.auth.signInWithPassword({ email, password })
  if (error) {
    return { success: false, error: error.message }
  }
  return { success: true }
}

export async function signOut(): Promise<void> {
  await supabase.auth.signOut()
}

export async function getSession() {
  const {
    data: { session },
  } = await supabase.auth.getSession()
  return session
}

export async function resetPassword(
  email: string,
): Promise<{ success: boolean; error?: string }> {
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/admin`,
  })
  if (error) {
    return { success: false, error: error.message }
  }
  return { success: true }
}
